import {action, actionOn} from 'easy-peasy';
import merge from 'deepmerge';
import {focusedAdviseSessionId} from 'hooks/chat-entry';
import {updateMessageStatus} from 'utils/chat';
import {overwriteMerge} from 'utils/deep-merge';

const updateMessagesStatus = (state, target) => {
  const {roomId, messages} = target.payload;

  const newStatus =
    focusedAdviseSessionId === roomId && document.visibilityState === 'visible'
      ? 'SEEN'
      : 'DELIVERED';

  for (const message of messages) {
    if (!message.out) {
      if (newStatus === 'DELIVERED' && message.status !== 'SENT') {
        continue;
      }

      if (
        newStatus === 'SEEN' &&
        message.status !== 'SENT' &&
        message.status !== 'DELIVERED'
      ) {
        continue;
      }

      updateMessageStatus(roomId, message.id, newStatus);
    }
  }
};

export default {
  /**
   * Structure
   * roomId : [messages]
   */

  clear: action((state) => ({})),

  appendMessages: action((state, payload) => {
    const {roomId, messages} = payload;
    state[roomId] = [...(state[roomId] || []), ...messages];
  }),

  prependMessages: action((state, payload) => {
    const {roomId, messages} = payload;
    state[roomId] = [...messages, ...(state[roomId] || [])];
  }),

  updateMessage: action((state, payload) => {
    const {roomId, messageId} = payload;
    const messages = state[roomId];
    if (messages) {
      const index = messages.findIndex((message) => message.id === messageId);

      if (index !== -1) {
        const message = messages[index];
        state[roomId][index] = merge(message, payload.payload, {
          arrayMerge: overwriteMerge,
        });
      }
    }
  }),

  /**
   * Listeners
   */

  onAppendMessages: actionOn(
    (actions, storeActions) => storeActions.chatRoom.appendMessages,
    (state, target) => updateMessagesStatus(state, target),
  ),

  onPrependMessages: actionOn(
    (actions, storeActions) => storeActions.chatRoom.prependMessages,
    (state, target) => updateMessagesStatus(state, target),
  ),
};
